import {
    CollisionComponent,
    Component,
    MeshComponent,
    Object3D,
} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {AnimationController} from '@wonderlandengine/tweenjs';
//@ts-ignore
import IdleAnimation from './animations/Mal@idle.json';
//@ts-ignore
import BlinkAnimation from './animations/Mal@blink.json';
import {RNG} from '../utils/rng.js';
import {WrapMode} from '@wonderlandengine/tweenjs/dist/wle/WrapMode.js';
import {CoroutineManager} from '../classes/coroutines/CoroutineManager.js';
import {waitForSeconds} from '../classes/coroutines/YieldInstructions.js';
import {Coroutine} from '../classes/coroutines/Coroutine.js';

export class MalFacialAnimationUi extends Component {
    static TypeName = 'mal-facial-animation-ui';

    @property.float(5)
    minimumBlinkDelay = 5;

    @property.float(10)
    maximumBlinkDelay = 10;

    private _phonemes: string[] = [
        `mouth_grin`,
        `mouth_u_w`,
        `mouth_mmm_pee_bee`,
        `mouth_oh`,
        `mouth_tongue_out`,
        `mouth_frown`,
    ];

    private _mouthMap: Map<string, MeshComponent> = new Map<string, MeshComponent>();

    private _animator: AnimationController;
    private _time: number = 0;
    private _currentBlinkDelay: number = 0;
    private _currentPhoneme: number = 0;
    private _coroutineManager = new CoroutineManager();

    get defaultExpression() {
        return this._mouthMap.get(this._phonemes[0]);
    }
    get tongueOut() {
        return this._mouthMap.get(this._phonemes[4]);
    }
    get frown() {
        return this._mouthMap.get(this._phonemes[5]);
    }

    init() {}

    start() {
        const mouth = this.object.findByNameRecursive('mouth')[0];
        this._phonemes.forEach((phoneme) => {
            const mesh = mouth.findByNameRecursive(phoneme)[0].getComponent(MeshComponent);
            this._mouthMap.set(phoneme, mesh);
        });

        this._animator = this.object
            .findByNameRecursive('mal_root')[0]
            .addComponent(AnimationController);
        this._animator.addClip(BlinkAnimation, 'blink');
        this._animator.addClip(IdleAnimation, 'idle');
        this._animator.setLayer('blink', 2);
        this._animator.play('idle');

        // bool showMouth = (faceControl != null) ? faceControl.MouthVisible : true;
        // if (showMouth)
        // {
        this._turnOffAllFacial();
        this.defaultExpression.active = true;
        //}
    }

    onActivate() {
        this._faceUpdaterId = this._coroutineManager.addCoroutine(
            new Coroutine(this._faceUpdater())
        );
    }
    onDeactivate(): void {
        this._coroutineManager.stopCoroutine(this._faceUpdaterId);
    }

    private _faceUpdaterId: number = -1;

    private *_faceUpdater() {
        //TK: until the speech is implemented, just use some random phonemes
        yield* waitForSeconds(RNG.getUniform(4, 8));
        while (true) {
            this.selectRandomPhoneme();
            yield* waitForSeconds(RNG.getUniform(1, 4));
            this._turnOffAllFacial();
            this.defaultExpression.active = true;
            yield* waitForSeconds(RNG.getUniform(4, 8));
        }
    }

    // onActivate(): void {
    //     if (this._animator) {
    //         this._animator.active = true;
    //     }
    // }
    // onDeactivate(): void {
    //     if (this._animator) {
    //         this._animator.active = false;
    //     }
    // }

    update(dt: number) {
        this._time += dt;
        this._coroutineManager.update(dt);
        if (this._time > this._currentBlinkDelay) {
            this._animator.play('blink');
            this._currentBlinkDelay =
                this._time + RNG.getUniform(this.minimumBlinkDelay, this.maximumBlinkDelay);
        }
    }

    public faceDefault(): void {
        // Comment: faceControl is not defined in this file yet
        // const showMouth = (faceControl != null) ? faceControl.MouthVisible : true;
        const showMouth = true;

        if (showMouth) {
            this._turnOffAllFacial();

            const rand = Math.floor(RNG.getUniform(0, 3));
            switch (rand) {
                case 0:
                    if (this.defaultExpression) {
                        this.defaultExpression.active = true;
                    }
                    break;
                case 1:
                    if (this.tongueOut) {
                        this.tongueOut.active = true;
                    }
                    break;
                case 2:
                    if (this.frown) {
                        this.frown.active = true;
                    }
                    break;
                default:
                    if (this.defaultExpression) {
                        this.defaultExpression.active = true;
                    }
                    break;
            }
        }
    }

    public selectRandomPhoneme(): void {
        // Comment: faceControl is not defined in this file yet
        // const showMouth = (faceControl != null) ? faceControl.MouthVisible : true;
        const showMouth = true;

        if (showMouth) {
            this._turnOffAllFacial();

            // prevent phonemes from repeating
            const phonemesArray = Array.from(this._mouthMap.values());
            let nextPhoneme = Math.floor(RNG.getUniform(0, phonemesArray.length));

            if (nextPhoneme === this._currentPhoneme) {
                nextPhoneme = (nextPhoneme + 1) % phonemesArray.length;
            }

            this._currentPhoneme = nextPhoneme;

            if (phonemesArray[this._currentPhoneme]) {
                phonemesArray[this._currentPhoneme].active = true;
            }
        }
    }

    private _turnOffAllFacial() {
        // bool showMouth = (faceControl != null) ? faceControl.MouthVisible : true;
        // if (showMouth)
        // {
        this._mouthMap.forEach((mesh) => {
            mesh.active = false;
        });
        //}
    }
}
